// extracted by extract-css-chunks-webpack-plugin
module.exports = {"block__title":"_2_gp61"};